import React from 'react';
import ModuleLayout from '../../components/ModuleLayout';

const ColostrumReplacerLayout = () => (
  <ModuleLayout moduleTitle="Colostrum Management" moduleName="colostrum-management" />
);

export default ColostrumReplacerLayout;
